import { FuseUtils } from '@fuse/utils';

export class TaskUpdatedTime {
    todoDate: string;
    inProgressDate: string;
    completedDate: string;
    readyForQaDate: string;
    reOpenDate: string;
    closedDate: string;

    constructor() {
        this.todoDate = '';
        this.inProgressDate = '';
        this.completedDate = '';
        this.readyForQaDate = '';
        this.reOpenDate = '';
        this.closedDate = '';
    }
}

export class Card {
    id: string;
    name: string;
    description: string;
    storyPoints: string;
    idAttachmentCover: string;
    idMembers: string[];
    idLabels: string[];
    attachments: any[];
    subscribed: boolean;
    checklists: any[];
    checkItems: number;
    checkItemsChecked: number;
    comments: any[];
    activities: any[];
    due: string;
    start: string;
    dueDate: string;
    startDate: string;
    taskRole: any[];
    priority: string;
    assignee: any[];
    estimatedHours: string;
    completedHours: string;
    estimatedHoursSecondsToHms: string;
    assigneesId: any[];
    taskType: any[];
    typeOfTask: string;
    boardListName: string;
    cardType: any;
    createdAt: any;

    taskUpdatedTime: any;
    todoDateActivity: any;
    inProgressDateActivity: any;
    completedDateActivity: any;
    readyForQaDateActivity: any;
    reOpenDateActivity: any;
    closedDateActivity: any;

    /**
     * Constructor
     *
     * @param card
     */
    constructor(card) {
        this.id = card.id || FuseUtils.generateGUID();
        this.name = card.name || '';
        this.description = card.description || '';
        this.storyPoints = card.storyPoints || '';
        this.idAttachmentCover = card.idAttachmentCover || '';
        this.idMembers = card.idMembers || [];
        this.idLabels = card.idLabels || [];
        this.attachments = card.attachments || [];
        this.subscribed = card.subscribed || true;
        this.checklists = card.checklists || [];
        this.checkItems = card.checkItems || 0;
        this.checkItemsChecked = card.checkItemsChecked || 0;
        this.comments = card.comments || [];
        this.activities = card.activities || [];
        this.due = card.due || '';
        this.start = card.start || '';
        this.taskRole = card.taskRole || [];
        this.taskType = card.taskType || [];
        this.typeOfTask = card.taskType || [];
        this.priority = card.priority || '';
        this.dueDate = card.dueDate || '';
        this.startDate = card.startDate || '';
        this.estimatedHours = card.estimatedHours || '';
        this.completedHours = card.completedHours || '';
        this.estimatedHoursSecondsToHms = card.estimatedHoursSecondsToHms || '';
        this.assignee = card.assignee || [];
        this.assigneesId = card.assigneesId || [];
        this.boardListName = card.boardListName || '';
        this.cardType = card.cardType || '';
        this.createdAt = card.createdAt || '';

        this.taskUpdatedTime = card.taskUpdatedTime || new TaskUpdatedTime();
        this.todoDateActivity = card.todoDateActivity || [];
        this.inProgressDateActivity = card.inProgressDateActivity || [];
        this.completedDateActivity = card.completedDateActivity || [];
        this.readyForQaDateActivity = card.readyForQaDateActivity || [];
        this.reOpenDateActivity = card.reOpenDateActivity || [];
        this.closedDateActivity = card.closedDateActivity || [];

    }
}
